import { useState } from "react";
import AdminLayout from "./AdminLayout";
import Overview from "./sections/Overview";
import BranchesSection from "./sections/BranchesSection";
import CoursesSection from "./sections/CoursesSection";
import EventsSection from "./sections/EventsSection";
import AnnouncementsSection from "./sections/AnnouncementsSection";
import SubmissionsSection from "./sections/SubmissionsSection";

export default function AdminDashboard() {
  const [active, setActive] = useState("overview");

  return (
    <AdminLayout active={active} onChange={setActive}>
      {active === "overview" && <Overview onNavigate={setActive} />}
      {active === "branches" && <BranchesSection />}
      {active === "courses" && <CoursesSection />}
      {active === "events" && <EventsSection />}
      {active === "announcements" && <AnnouncementsSection />}
      {active === "submissions" && <SubmissionsSection />}
    </AdminLayout>
  );
}
